<template>
  <div>
    <div class="bottom-line" v-if="page <= 10">
      <img :src="path+('bottom-line.png')">
    </div>
    <!--口腔問題-->
    <div class="test-p2 rd-test" v-if="page <= 10">
      <div class="card-area"
           @mousedown="handleMouseDown"
           @mouseup="handleMouseUp"
           @mousemove="handleMouseMove"
           @touchstart="handleTouchStart"
           @touchend="handleTouchEnd">
        <!--點擊yes就給yes no就給no 點擊同時"下一張"要加上now-->
        <div class="card-item t2pic1 firstcard" v-bind:class="{yes: answers[0].answer === true,no: answers[0].answer === false}">
            <div class="rel-formove">
                <div class="shadow-area"></div>
                <div class="yes-mark">
                    <img :src="path+('cry-7.gif')">
                </div>
                <div class="no-mark">
                    <img :src="path+('smile-7.gif')">
                </div>
              <div class="full-mask"></div>
              <div class="ribbon-title">
                <div class="left-area">
                  <div class="num-title">
                    <img :src="path+('Q1.svg')">
                  </div>
                  <h2>
                    刷牙時流血或是有粉紅色的泡泡
                  </h2>
                </div>
                <div class="arrsvg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                    <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#63C5F1"/>
                  </svg>
                </div>
              </div>
            </div>
        </div>
        <div class="card-item t2pic2" v-bind:class="{now: page === 2 || page === 3, yes: answers[1].answer === true,no: answers[1].answer === false}">
            <div class="rel-formove">
                <div class="shadow-area"></div>
                <div class="yes-mark">
                    <img :src="path+('cry-8.gif')">
                </div>
                <div class="no-mark">
                    <img :src="path+('smile-8.gif')">
                </div>
              <div class="full-mask"></div>
              <div class="ribbon-title">
                <div class="left-area">
                  <div class="num-title">
                    <img :src="path+('Q2.svg')">
                  </div>
                  <h2>
                    吃有嚼勁食物牙齒卡卡不舒服
                  </h2>
                </div>
                <div class="arrsvg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                    <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#63C5F1"/>
                  </svg>
                </div>
              </div>
            </div>
        </div>
        <div class="card-item t2pic3" v-bind:class="{now: page === 3 || page === 4, yes: answers[2].answer === true,no: answers[2].answer === false}">
            <div class="rel-formove">
              <div class="shadow-area"></div>
                <div class="yes-mark">
                    <img :src="path+('cry-9.gif')">
                </div>
                <div class="no-mark">
                    <img :src="path+('smile-9.gif')">
                </div>
              <div class="full-mask"></div>
              <div class="ribbon-title">
                <div class="left-area">
                  <div class="num-title">
                    <img :src="path+('Q3.svg')">
                  </div>
                  <h2>
                    被提醒口腔有異味
                  </h2>
                </div>
                <div class="arrsvg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                    <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#63C5F1"/>
                  </svg>
                </div>
              </div>
            </div>
        </div>
        <div class="card-item t2pic4" v-bind:class="{now: page === 4 || page === 5, yes: answers[3].answer === true,no: answers[3].answer === false}">
            <div class="rel-formove">
                <div class="shadow-area"></div>
                <div class="yes-mark">
                    <img :src="path+('cry-10.gif')">
                </div>
                <div class="no-mark">
                    <img :src="path+('smile-10.gif')">
                </div>
              <div class="full-mask"></div>
              <div class="ribbon-title">
                <div class="left-area">
                  <div class="num-title">
                    <img :src="path+('Q4.svg')">
                  </div>
                  <h2>
                    吃太硬的蘋果，覺得牙齒不舒服
                  </h2>
                </div>
                <div class="arrsvg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                    <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#63C5F1"/>
                  </svg>
                </div>
              </div>
            </div>
        </div>
        <div class="card-item t2pic5" v-bind:class="{now: page === 5 || page === 6, yes: answers[4].answer === true,no: answers[4].answer === false}">
            <div class="rel-formove">
                <div class="shadow-area"></div>
                <div class="yes-mark">
                    <img :src="path+('cry-11.gif')">
                </div>
                <div class="no-mark">
                    <img :src="path+('smile-11.gif')">
                </div>
              <div class="full-mask"></div>
              <div class="ribbon-title">
                <div class="left-area">
                  <div class="num-title">
                    <img :src="path+('Q5.svg')">
                  </div>
                  <h2>
                    使用牙線時發現流血
                  </h2>
                </div>
                <div class="arrsvg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                    <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#63C5F1"/>
                  </svg>
                </div>
              </div>
            </div>
        </div>
        <div class="card-item t2pic6" v-bind:class="{now: page === 6 || page === 7, yes: answers[5].answer === true,no: answers[5].answer === false}">
            <div class="rel-formove">
                <div class="shadow-area"></div>
                <div class="yes-mark">
                    <img :src="path+('cry-12.gif')">
                </div>
                <div class="no-mark">
                    <img :src="path+('smile-12.gif')">
                </div>
              <div class="full-mask"></div>
              <div class="ribbon-title">
                <div class="left-area">
                  <div class="num-title">
                    <img :src="path+('Q6.svg')">
                  </div>
                  <h2>
                    喝到熱飲/熱湯牙齒會有短暫酸痛
                  </h2>
                </div>
                <div class="arrsvg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                    <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#63C5F1"/>
                  </svg>
                </div>
              </div>
            </div>
        </div>
        <div class="card-item t2pic7" v-bind:class="{now: page === 7 || page === 8, yes: answers[6].answer === true,no: answers[6].answer === false}">
            <div class="rel-formove">
                <div class="shadow-area"></div>
                <div class="yes-mark">
                    <img :src="path+('cry-13.gif')">
                </div>
                <div class="no-mark">
                    <img :src="path+('smile-13.gif')">
                </div>
              <div class="full-mask"></div>
              <div class="ribbon-title">
                <div class="left-area">
                  <div class="num-title">
                    <img :src="path+('Q7.svg')">
                  </div>
                  <h2>
                    喝超冰飲料牙齒會酸痛
                  </h2>
                </div>
                <div class="arrsvg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                    <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#63C5F1"/>
                  </svg>
                </div>
              </div>
            </div>
        </div>
        <div class="card-item t2pic9" v-bind:class="{now: page === 8 || page === 9, yes: answers[7].answer === true,no: answers[7].answer === false}">
            <div class="rel-formove">
                <div class="shadow-area"></div>
                <div class="yes-mark">
                    <img :src="path+('cry-14.gif')">
                </div>
                <div class="no-mark">
                    <img :src="path+('smile-14.gif')">
                </div>
              <div class="full-mask"></div>
              <div class="ribbon-title">
                <div class="left-area">
                  <div class="num-title">
                    <img :src="path+('Q8.svg')">
                  </div>
                  <h2>
                    咬緊牙關吸一口氣，牙齒有刺痛感
                  </h2>
                </div>
                <div class="arrsvg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                    <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#63C5F1"/>
                  </svg>
                </div>
              </div>
            </div>
        </div>
        <div class="card-item t2pic10" v-bind:class="{now: page === 9 || page === 10, yes: answers[8].answer === true,no: answers[8].answer === false}">
            <div class="rel-formove">
                <div class="shadow-area"></div>
                <div class="yes-mark">
                    <img :src="path+('cry-15.gif')">
                </div>
                <div class="no-mark">
                    <img :src="path+('smile-15.gif')">
                </div>
              <div class="full-mask"></div>
              <div class="ribbon-title">
                <div class="left-area">
                  <div class="num-title">
                    <img :src="path+('Q9.svg')">
                  </div>
                  <h2>
                    怕牙齒刺痛不敢大口吃冰
                  </h2>
                </div>
                <div class="arrsvg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                    <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#63C5F1"/>
                  </svg>
                </div>
              </div>
            </div>
        </div>
        <div class="card-item t2pic11" v-bind:class="{now: page === 10 || page === 11, yes: answers[9].answer === true,no: answers[9].answer === false}">
            <div class="rel-formove">
                <div class="shadow-area"></div>
                <div class="yes-mark">
                    <img :src="path+('cry-16.gif')">
                </div>
                <div class="no-mark">
                    <img :src="path+('smile-16.gif')">
                </div>
              <div class="full-mask"></div>
              <div class="ribbon-title">
                <div class="left-area">
                  <div class="num-title">
                    <img :src="path+('Q10.svg')">
                  </div>
                  <h2>
                    吃到酸酸的食物，牙齒會一陣酸軟
                  </h2>
                </div>
                <div class="arrsvg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="80" viewBox="0 0 23 80" fill="none">
                    <path d="M0 42.4713L22.0858 0H0V80H23L0 42.4713Z" fill="#63C5F1"/>
                  </svg>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div class="page-num">
        <p v-text="page">1</p>
        <span>/</span>
        <p>10</p>
      </div>
      <div class="yn-btn-area">
        <button class="nobtn" v-on:click="selectAnswer(false)">
          <img :src="path+('NOg.svg')">
        </button>
        <button class="yesbtn" v-on:click="selectAnswer(true)">
          <img :src="path+('YESg.svg')">
        </button>
      </div>
    </div>
    <!--口腔結果1 敏感牙3星-->
    <div class="resbg rd-result" v-if="star === 3">
      <div class="mask-blue"></div>
      <div class="content-area">
        <div class="top-pad12">
          <div class="kv">
            <img :src="path+('resp2-1.png')">
          </div>
          <div class="feature-box">
            <img :src="path+('ficon4.svg')">
            <p>太冰、太熱不行！<br>
              太酸、太甜不行！</p>
            <img :src="path+('ficon5.svg')">
          </div>
          <div class="main-title">
            <img :src="path+('main-title5.svg')">
          </div>
        </div>
        <div class="pr-are blue">
          <div class="border-box ">
            <div class="titlebox">
              <img :src="path+('titletip2.png')">
            </div>
            <h3 class="col-blue">
              不想被敏感困擾擊垮，<br>
              就要盡快處理敏感牙！
            </h3>
            <ul class="pr-list">
              <li>
                <div class="pr-box bluebg">
                  <img :src="path+('pr3.png')">
                </div>
                <div>
                  <p>交給<span class="col-blue">舒酸定專業修復抗敏牙膏</span>，專為敏感牙所設計，深層修復敏感性牙齒<span class="col-red">*</span></p>
                  <p class="note">
                    <span class="col-red">*</span>
                    每天刷牙兩次，並配合正確刷牙習慣
                  </p>
                </div>
              </li>
            </ul>
            <div class="flex-center">
              <a class="share-result" v-on:click="share(path+('Share_口腔問題_score_50_敏感牙-1.jpg'))">
                <img :src="path+('txt-result.svg')">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                  <path d="M15 10.3937L6 15.5898L6 5.19751L15 10.3937Z" fill="white"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="othertest greenbg" v-if="show_retainer">
        <div class="flex-area">
          <img class="peo" :src="path+('doc2.svg')">
          <div class="right-area">
            <div class="top-flex">
              <img :src="path+('lampicon.svg')">
              <h3>有配戴隱形牙套的你</h3>
            </div>
            <a href="javascript:void ('')" class="link-btn" v-on:click="switchRetainerTest">
              <img :src="path+('btnfont2.svg')">

              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M15 10.3937L6 15.5898L6 5.19751L15 10.3937Z" fill="#808080"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!--口腔結果2 牙齦3星-->
    <div class="resbg rd-result" v-if="star === 4">
      <div class="mask-red"></div>
      <div class="content-area">
        <div class="top-pad12">
          <div class="kv">
            <img :src="path+('resp2-2.png')">
          </div>
          <div class="feature-box">
            <img :src="path+('ficon4.svg')">
            <p>太硬、太Q牙齒總卡卡，<br>
              嘴巴更有異味！</p>
            <img :src="path+('ficon1.svg')">
          </div>
          <div class="main-title">
            <img :src="path+('main-title6.svg')">
          </div>
        </div>
        <div class="pr-are red">
          <div class="border-box ">
            <div class="titlebox">
              <img :src="path+('titletip3.png')">
            </div>
            <h3 class="col-red">
              不想讓牙齦卡卡影響吃美食，<br>
              即刻啟動牙齦護理！
            </h3>
            <ul class="pr-list">
              <li>
                <div class="pr-box ">
                  <img :src="path+('pr4.png')">
                </div>
                <div>
                  <p>
                    交給<span class="col-red">牙周適牙齦護理牙膏</span>，獨家配方，更有效幫助清除超過50%牙菌斑<span class="col-red">^</span>
                  </p>
                  <p class="note">
                    <span class="col-red">^</span>
                    刷牙一分鐘後與一般單純含氟牙膏相比，針對難以清潔的牙縫，可幫助清除50%更多的牙菌斑，須配合正確刷牙習慣。產品實際使用效果可能因人而異
                  </p>
                </div>
              </li>
            </ul>
            <div class="flex-center">
              <a class="share-result" v-on:click="share(path+('Share_口腔問題_score_50_牙齦.jpg'))">
                <img :src="path+('txt-result.svg')">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                  <path d="M15 10.3937L6 15.5898L6 5.19751L15 10.3937Z" fill="white"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="othertest greenbg" v-if="show_retainer">
        <div class="flex-area">
          <img class="peo" :src="path+('doc2.svg')">
          <div class="right-area">
            <div class="top-flex">
              <img :src="path+('lampicon.svg')">
              <h3>有配戴隱形牙套的你</h3>
            </div>
            <a href="javascript:void ('')" class="link-btn" v-on:click="switchRetainerTest">
              <img :src="path+('btnfont2.svg')">

              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M15 10.3937L6 15.5898L6 5.19751L15 10.3937Z" fill="#808080"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!--口腔結果3 雙重2星-->
    <div class="resbg rd-result" v-if="star === 2">
      <div class="mask-blue"></div>
      <div class="content-area">
        <div class="top-pad12">
          <div class="kv">
            <img :src="path+('resp2-3.png')">
          </div>
          <div class="feature-box">
            <img :src="path+('ficon4.svg')">
            <p>冰熱酸甜都會怕，<br>
              太硬太Q也牙齒卡卡！</p>
            <img :src="path+('ficon5.svg')">
          </div>
          <div class="main-title">
            <img :src="path+('main-title7.svg')">
          </div>
        </div>
        <div class="pr-are bluered">
          <div class="border-box ">
            <div class="titlebox">
              <img :src="path+('titletip2.png')">
            </div>
            <h3 class="col-blue">
              問題疊加讓你吃什麼都不盡興？<br>
              解救吃貨潛力要兩種問題一起處理！
            </h3>
            <ul class="pr-list">
              <li>
                <div class="pr-box bluebg">
                  <img :src="path+('pr5.png')">
                </div>
                <div>
                  <p>
                    <span class="col-blue">舒酸定專業抗敏護齦牙膏</span><br>
                    修復牙齒敏感、並助清除牙菌斑，幫助促進牙齦健康
                  </p>
                  <p class="note">
                    <span class="col-red">*</span>
                    每天刷牙兩次，並配合正確刷牙習慣
                  </p>
                </div>
              </li>
            </ul>
            <div class="flex-center">
              <a class="share-result" v-on:click="share(path+('Share_口腔問題_score_20_雙重.jpg'))">
                <img :src="path+('txt-result.svg')">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                  <path d="M15 10.3937L6 15.5898L6 5.19751L15 10.3937Z" fill="white"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="othertest greenbg" v-if="show_retainer">
        <div class="flex-area">
          <img class="peo" :src="path+('doc2.svg')">
          <div class="right-area">
            <div class="top-flex">
              <img :src="path+('lampicon.svg')">
              <h3>有配戴隱形牙套的你</h3>
            </div>
            <a href="javascript:void ('')" class="link-btn" v-on:click="switchRetainerTest">
              <img :src="path+('btnfont2.svg')">

              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M15 10.3937L6 15.5898L6 5.19751L15 10.3937Z" fill="#808080"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!--口腔結果4 敏感牙5星-->
    <div class="resbg rd-result" v-if="star === 5">
      <div class="mask-blue"></div>
      <div class="content-area">
        <div class="top-pad12">
          <div class="kv">
            <img :src="path+('resp2-4.png')">
          </div>
          <div class="feature-box">
            <img :src="path+('ficon6.svg')">
            <p>冰熱酸甜都ok，<br>
                Q彈脆硬輕鬆咬！</p>
            <img :src="path+('ficon7.svg')">
          </div>
          <div class="main-title">
            <img :src="path+('main-title8.svg')">
          </div>
        </div>
        <div class="pr-are bluered">
          <div class="border-box ">
            <div class="titlebox">
              <img :src="path+('titletip2.png')">
            </div>
            <h3 class="col-blue">
              想要持續勝任吃貨冠軍，<br>
              要謹記持續清潔並留意口腔狀況！
            </h3>
            <ul class="pr-list">
              <li>
                <div class="pr-box redbg">
                  <img :src="path+('pr4.png')">
                </div>
                <div>
                  <p>
                    <span class="col-red">牙周適牙齦護齦牙膏</span>，幫助維持牙齦健康！
                  </p>
                </div>
              </li>
              <li>
                <div class="pr-box ">
                  <img :src="path+('pr3.png')">
                </div>
                <div>
                  <p>
                    若驚覺敏感牙發生，<span class="col-blue">舒酸定專業修復抗敏牙膏</span>，幫助處理敏感牙問題！
                  </p>
                  <p class="note">
                    <span class="col-red">*</span>
                    每天刷牙兩次，並配合正確刷牙習慣
                  </p>
                </div>
              </li>
            </ul>
            <div class="flex-center">
              <a class="share-result" v-on:click="share(path+('Share_口腔問題_score_50_敏感牙.jpg'))">
                <img :src="path+('txt-result.svg')">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                  <path d="M15 10.3937L6 15.5898L6 5.19751L15 10.3937Z" fill="white"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="othertest greenbg" v-if="show_retainer">
        <div class="flex-area">
          <img class="peo" :src="path+('doc2.svg')">
          <div class="right-area">
            <div class="top-flex">
              <img :src="path+('lampicon.svg')">
              <h3>有配戴隱形牙套的你</h3>
            </div>
            <a href="javascript:void ('')" class="link-btn" v-on:click="switchRetainerTest">
              <img :src="path+('btnfont2.svg')">

              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M15 10.3937L6 15.5898L6 5.19751L15 10.3937Z" fill="#808080"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {gsap} from "gsap";
  import Vue from "vue";

  export default {
    props: ["path", "show_retainer"],
    name:"MouthTest",
    data() {
      return {
        page:1,
        answers:[
          {
            answer:null,
          },
          {
            answer:null,
          },
          {
            answer:null,
          },
          {
            answer:null,
          },
          {
            answer:null,
          },
          {
            answer:null,
          },
          {
            answer:null,
          },
          {
            answer:null,
          },
          {
            answer:null,
          },
          {
            answer:null,
          }
        ],
        star:0,
          touch:{
              enable:true,
              startX: 0,
              currentX: 0,
          }
      }
    },
    components:{
    },
    methods: {
        handleTouchStart(event) {
            this.touch.startX = event.touches[0].clientX;
        },
        handleTouchEnd(event) {
            let endX = event.changedTouches[0].clientX;
            this.detectDirection(endX - this.touch.startX);
        },
        handleMouseDown(event) {
            this.touch.startX = event.clientX;
            window.addEventListener('mousemove', this.handleMouseMove);
        },
        handleMouseMove(event) {
            this.touch.currentX = event.clientX;
        },
        handleMouseUp(event) {
            window.removeEventListener('mousemove', this.handleMouseMove);
            this.detectDirection(this.touch.currentX - this.touch.startX);
        },
        detectDirection(distance) {
            const threshold = 20;

            if(this.touch.enable){
                if (distance > threshold) {
                    this.touch.enable = false
                    this.touch.startX = 0
                    this.touch.currentX = 0
                    this.selectAnswer(true)
                } else if (distance < -threshold) {
                    this.touch.enable = false
                    this.touch.startX = 0
                    this.touch.currentX = 0
                    this.selectAnswer(false)
                }
            }
        },
      share(url){
        this.$emit('share', url)
      },
      switchRetainerTest(){
        let _this = this
        gsap.to('.rd-result',{opacity:0, duration:.3, onComplete:function () {
            _this.$emit('switch-component', 'retainer-test')
            _this.$emit('close-result')
          }})
      },
      selectAnswer(answer){
        const _this = this
        this.answers[this.page-1].answer = answer
        this.page++
        if(this.page === 11){
          this.showResult()
        }
          setTimeout(function () {
              _this.touch.enable = true
          }, 1000)
      },
      showResult(){
        let _this = this

        gsap.to('.rd-test',{opacity:0, duration:.3, onComplete:function () {
            _this.$emit('open-result')

            let count = _this.answers.filter(item => item.answer === true).length;

            if(count === 0){
              _this.star = 5
            }else if((_this.answers[0].answer || _this.answers[1].answer || _this.answers[3].answer || _this.answers[4].answer) && (_this.answers[5].answer || _this.answers[6].answer || _this.answers[7].answer || _this.answers[8].answer || _this.answers[9].answer)){
              _this.star = 2
            }else if(_this.answers[5].answer ||_this.answers[6].answer || _this.answers[7].answer || _this.answers[8].answer || _this.answers[9].answer){
              _this.star = 3
            }else if(_this.answers[0].answer || _this.answers[1].answer || _this.answers[2].answer || _this.answers[3].answer || _this.answers[4].answer){
              _this.star = 4
            }

            Vue.nextTick(function () {
              gsap.to('.rd-result',{opacity:1, duration:.3})
            })
          }})
      }
    },
    mounted() {
      gsap.to('.rd-test',{opacity:1, duration:.5})
    }
  }
</script>

